export var HighLowRollverEGLType;
(function (HighLowRollverEGLType) {
    HighLowRollverEGLType["HIGHROLLOVER"] = "highRollover";
    HighLowRollverEGLType["LOWROLLOVER"] = "lowRollover";
})(HighLowRollverEGLType || (HighLowRollverEGLType = {}));
